export const projectData = {
    name: 'Rehsult',
    description: 'Sistema de educação para o agronegócio',
    url: 'https://pfa.rehagro.com.br',
    image: '%PUBLIC_URL%/favicon.ico',
    author: 'Rehagro',
    keywords: ['agronegocio', 'agroecologia']
};
